import { useState, useEffect, useRef } from "react";

// â”€â”€ Default brand config (overridable via Appearances) â”€â”€â”€â”€
const DEFAULT_BRAND = {
  businessName: "Edith Ave Creative",
  tagline: "Look as good as the work you do",
  colors: {
    primary: "#555749",
    primaryLight: "#6B6D5E",
    primaryFaint: "#F2F1EE",
    accent: "#B1A496",
    accentFaint: "#F5F2EF",
    stone: "#D5D4D2",
    cream: "#EFEAE7",
    blush: "#DEC3B9",
    text: "#2A2A28",
    textMid: "#555749",
    textLight: "#8A8880",
    white: "#FFFFFF",
  },
  fonts: {
    heading: "Cormorant Garamond",
    body: "Montserrat",
    headingUrl: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&display=swap",
    bodyUrl: "https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600&display=swap",
  },
};

// â”€â”€ Default service types â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const DEFAULT_SERVICES = [
  {
    id: "photography",
    label: "Brand Photography",
    color: "#B1A496",
    stages: ["Inquiry","Booked","Pre-Shoot Prep","Shoot Day","Editing","Gallery Ready","Complete"],
    questionnaireUrl: "",
    autoDocs: [
      { name: "Photography Welcome Guide", type: "Welcome Guide" },
      { name: "Photography Contract", type: "Contract" },
      { name: "Pre-Shoot Questionnaire", type: "Questionnaire" },
    ],
  },
  {
    id: "product",
    label: "Product Photography",
    color: "#C1916F",
    stages: ["Inquiry","Booked","Shot List Review","Shoot Day","Editing","Gallery Ready","Complete"],
    questionnaireUrl: "",
    autoDocs: [
      { name: "Product Photography Welcome Guide", type: "Welcome Guide" },
      { name: "Product Photography Contract", type: "Contract" },
      { name: "Product Shot List", type: "Questionnaire" },
    ],
  },
  {
    id: "brand",
    label: "Brand Identity Design",
    color: "#555749",
    stages: ["Inquiry","Proposal Sent","Booked","Discovery","Design","Revisions","Files Delivered","Complete"],
    questionnaireUrl: "https://tally.so/r/aQVXZB",
    autoDocs: [
      { name: "Brand Identity Welcome Guide", type: "Welcome Guide" },
      { name: "Brand Identity Contract", type: "Contract" },
      { name: "Brand Questionnaire", type: "Questionnaire" },
    ],
  },
  {
    id: "website",
    label: "Website Design",
    color: "#DEC3B9",
    stages: ["Inquiry","Proposal Sent","Booked","Strategy","Design","Development","Review","Launched","Complete"],
    questionnaireUrl: "",
    autoDocs: [
      { name: "Website Design Welcome Guide", type: "Welcome Guide" },
      { name: "Website Design Contract", type: "Contract" },
      { name: "Website Strategy Questionnaire", type: "Questionnaire" },
    ],
  },
];

const DOC_TYPES = ["Contract","Invoice","Proposal","Welcome Guide","Brand Guidelines","Questionnaire","Shot List","Other"];
const ADMIN_CODE = "neA52116!";
const uid = () => Math.random().toString(36).slice(2,9);
const today = () => new Date().toISOString().slice(0,10);
const fmtDate = d => d ? new Date(d+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "";
const initials = name => name.split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);

// â”€â”€ Storage â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
async function load(key, fallback) {
  try { const r = await window.storage.get(key); if (r?.value) return JSON.parse(r.value); } catch(_){}
  return fallback;
}
async function save(key, val) {
  try { await window.storage.set(key, JSON.stringify(val)); } catch(_){}
}

// â”€â”€ Seed clients â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SEED_CLIENTS = [
  {
    id:"c1", name:"Maya Rivera", email:"maya@example.com", phone:"(816) 555-0142",
    businessName:"Maple & Co.", code:"MAYA2024",
    services: [
      { serviceId:"brand", stage:3 },
      { serviceId:"product", stage:1 },
    ],
    startDate:"2024-06-01", notes:"Product brand â€” candles and home goods.",
    meetings:[
      {id:"m1",title:"Discovery Call",date:"2024-06-05",time:"10:00 AM",link:"https://meet.google.com/abc",notes:"Bring questionnaire responses."},
      {id:"m2",title:"Concept Presentation",date:"2024-07-10",time:"2:00 PM",link:"https://meet.google.com/xyz",notes:"Review 2 initial directions."},
    ],
    documents:[
      {id:"d1",name:"Brand Identity Welcome Guide",type:"Welcome Guide",url:"#",date:"2024-06-01",visible:true},
      {id:"d2",name:"Brand Identity Contract",type:"Contract",url:"#",date:"2024-06-01",visible:true},
      {id:"d3",name:"Brand Questionnaire",type:"Questionnaire",url:"#",date:"2024-06-01",visible:true},
    ],
    files:[],
  },
  {
    id:"c2", name:"Claire Whitfield", email:"claire@example.com", phone:"(913) 555-0198",
    businessName:"Whitfield Interiors", code:"CLAIRE2024",
    services:[{serviceId:"website",stage:1}],
    startDate:"2024-06-10", notes:"Full rebrand + website. Service-based business.",
    meetings:[{id:"m3",title:"Discovery Call",date:"2024-07-15",time:"11:00 AM",link:"#",notes:""}],
    documents:[{id:"d4",name:"Website Proposal",type:"Proposal",url:"#",date:"2024-06-10",visible:true}],
    files:[],
  },
  {
    id:"c3", name:"Sarah Okonkwo", email:"sarah@example.com", phone:"(816) 555-0267",
    businessName:"Okonkwo Pottery", code:"SARAH2024",
    services:[{serviceId:"product",stage:5}],
    startDate:"2024-05-20", notes:"Product photography for e-commerce launch.",
    meetings:[{id:"m4",title:"Pre-Shoot Consultation",date:"2024-05-25",time:"1:00 PM",link:"#",notes:"Styling and props."}],
    documents:[
      {id:"d5",name:"Product Photography Welcome Guide",type:"Welcome Guide",url:"#",date:"2024-05-20",visible:true},
      {id:"d6",name:"Photography Contract",type:"Contract",url:"#",date:"2024-05-20",visible:true},
      {id:"d7",name:"Invoice â€” Paid in Full",type:"Invoice",url:"#",date:"2024-05-20",visible:true},
    ],
    files:[{id:"f1",name:"Okonkwo Pottery â€” Edited Gallery",url:"#",date:"2024-06-05"}],
  },
];

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// STYLES (dynamic, uses brand config)
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
function buildCSS(B) {
  return `
@import url('${B.fonts.headingUrl}');
@import url('${B.fonts.bodyUrl}');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
body{font-family:'${B.fonts.body}',sans-serif;background:${B.colors.cream};color:${B.colors.text};min-height:100vh;}
a{color:${B.colors.primary};text-decoration:none;}a:hover{text-decoration:underline;}

/* Layout */
.app-wrap{display:flex;min-height:100vh;}
.sidebar{width:220px;min-height:100vh;background:${B.colors.primary};display:flex;flex-direction:column;flex-shrink:0;position:sticky;top:0;height:100vh;overflow-y:auto;}
.main{flex:1;min-width:0;display:flex;flex-direction:column;}
.topbar{background:${B.colors.white};border-bottom:1px solid ${B.colors.stone};padding:0 28px;height:56px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
.content{padding:28px;flex:1;}

/* Sidebar */
.sb-logo{padding:28px 20px 20px;border-bottom:1px solid rgba(255,255,255,0.1);}
.sb-logo-main{font-family:'${B.fonts.heading}',serif;font-weight:300;font-size:18px;color:${B.colors.white};letter-spacing:0.14em;text-transform:uppercase;}
.sb-logo-sub{font-family:'${B.fonts.heading}',serif;font-style:italic;font-weight:300;font-size:13px;color:${B.colors.accent};margin-top:1px;}
.sb-section{font-size:9px;font-weight:600;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,0.3);padding:18px 20px 6px;}
.nav-item{display:flex;align-items:center;gap:9px;padding:9px 20px;font-size:11px;font-weight:500;letter-spacing:0.04em;color:rgba(255,255,255,0.6);cursor:pointer;transition:all 0.15s;border:none;background:none;width:100%;text-align:left;}
.nav-item:hover{color:${B.colors.white};background:rgba(255,255,255,0.07);}
.nav-item.active{color:${B.colors.white};background:rgba(255,255,255,0.12);border-left:2px solid ${B.colors.accent};}
.nav-item svg{width:14px;height:14px;stroke:currentColor;fill:none;flex-shrink:0;}
.nav-bottom{margin-top:auto;border-top:1px solid rgba(255,255,255,0.1);padding:8px 0;}

/* Client sidebar (left nav) */
.client-sidebar{width:220px;min-height:100vh;background:${B.colors.primary};display:flex;flex-direction:column;flex-shrink:0;}
.client-sb-header{padding:24px 20px;border-bottom:1px solid rgba(255,255,255,0.1);}
.client-sb-name{font-family:'${B.fonts.heading}',serif;font-size:16px;font-weight:300;color:${B.colors.white};letter-spacing:0.06em;margin-bottom:2px;}
.client-sb-biz{font-size:11px;color:rgba(255,255,255,0.5);}
.client-nav{flex:1;padding:8px 0;}
.client-nav-item{display:flex;align-items:center;gap:9px;padding:10px 20px;font-size:11px;font-weight:500;letter-spacing:0.03em;color:rgba(255,255,255,0.6);cursor:pointer;transition:all 0.15s;border:none;background:none;width:100%;text-align:left;}
.client-nav-item:hover{color:${B.colors.white};background:rgba(255,255,255,0.07);}
.client-nav-item.active{color:${B.colors.white};background:rgba(255,255,255,0.12);border-left:2px solid ${B.colors.accent};}
.client-nav-item svg{width:13px;height:13px;stroke:currentColor;fill:none;flex-shrink:0;}
.client-nav-section{font-size:9px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:rgba(255,255,255,0.28);padding:14px 20px 4px;}
.client-bottom{margin-top:auto;border-top:1px solid rgba(255,255,255,0.1);padding:8px 0;}

/* Cards */
.card{background:${B.colors.white};border:1px solid ${B.colors.stone};border-radius:3px;}
.card-header{padding:18px 22px;border-bottom:1px solid ${B.colors.stone};display:flex;align-items:center;justify-content:space-between;}
.card-title{font-family:'${B.fonts.heading}',serif;font-size:18px;font-weight:300;}
.card-body{padding:22px;}
.stat-card{background:${B.colors.white};border:1px solid ${B.colors.stone};border-radius:3px;padding:18px 22px;}
.stat-label{font-size:9px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:${B.colors.textLight};margin-bottom:6px;}
.stat-value{font-family:'${B.fonts.heading}',serif;font-size:34px;font-weight:300;color:${B.colors.text};line-height:1;}

/* Grid */
.grid-2{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:18px;}
.grid-3{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:14px;}
.grid-4{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;}

/* Client card */
.client-card{background:${B.colors.white};border:1px solid ${B.colors.stone};border-radius:3px;padding:18px;cursor:pointer;transition:border-color 0.15s;}
.client-card:hover{border-color:${B.colors.accent};}
.avatar{border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:600;flex-shrink:0;}

/* Badges / tags */
.badge{display:inline-flex;align-items:center;gap:4px;padding:2px 9px;border-radius:20px;font-size:10px;font-weight:600;letter-spacing:0.04em;}
.badge-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0;}
.tag{display:inline-block;padding:2px 8px;background:${B.colors.cream};border:1px solid ${B.colors.stone};border-radius:2px;font-size:10px;font-weight:500;color:${B.colors.textMid};}

/* Stage */
.stage-track{height:3px;background:${B.colors.stone};border-radius:2px;overflow:hidden;margin-top:6px;}
.stage-fill{height:100%;background:${B.colors.primary};border-radius:2px;transition:width 0.4s;}
.stage-steps{display:flex;flex-wrap:wrap;gap:0;}
.stage-step{flex:1;min-width:54px;text-align:center;position:relative;padding-bottom:18px;}
.stage-step::before{content:'';position:absolute;top:8px;left:-50%;right:50%;height:2px;background:${B.colors.stone};}
.stage-step:first-child::before{display:none;}
.stage-step.done::before{background:${B.colors.primary};}
.step-dot{width:18px;height:18px;border-radius:50%;border:2px solid ${B.colors.stone};background:${B.colors.white};margin:0 auto 5px;display:flex;align-items:center;justify-content:center;font-size:8px;color:${B.colors.textLight};position:relative;z-index:1;transition:all 0.2s;}
.stage-step.done .step-dot{background:${B.colors.primary};border-color:${B.colors.primary};color:${B.colors.white};}
.stage-step.current .step-dot{background:${B.colors.white};border-color:${B.colors.primary};box-shadow:0 0 0 3px rgba(85,87,73,0.15);}
.step-label{font-size:8px;color:${B.colors.textLight};font-weight:500;line-height:1.3;}
.stage-step.done .step-label{color:${B.colors.textMid};}
.stage-step.current .step-label{color:${B.colors.primary};font-weight:600;}

/* Table */
.tbl{width:100%;border-collapse:collapse;font-size:13px;}
.tbl th{text-align:left;font-size:9px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:${B.colors.textLight};padding:0 14px 8px 0;border-bottom:1px solid ${B.colors.stone};}
.tbl td{padding:10px 14px 10px 0;border-bottom:1px solid ${B.colors.cream};vertical-align:middle;}
.tbl tr:last-child td{border-bottom:none;}
.tbl tr:hover td{background:${B.colors.accentFaint};}

/* Meeting card */
.meeting-card{border:1px solid ${B.colors.stone};border-radius:3px;padding:14px 18px;display:flex;align-items:flex-start;gap:14px;}
.meeting-date-block{text-align:center;min-width:44px;background:${B.colors.primaryFaint};border-radius:2px;padding:7px 5px;}
.meeting-month{font-size:9px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:${B.colors.primary};}
.meeting-day{font-family:'${B.fonts.heading}',serif;font-size:24px;font-weight:300;color:${B.colors.text};line-height:1;}
.meeting-title{font-size:13px;font-weight:500;color:${B.colors.text};}
.meeting-time{font-size:11px;color:${B.colors.textLight};margin-top:1px;}
.meeting-note{font-size:11px;color:${B.colors.textMid};margin-top:5px;font-style:italic;}

/* File card */
.file-card{border:1px solid ${B.colors.stone};border-radius:3px;padding:12px 16px;display:flex;align-items:center;gap:12px;}
.file-icon{width:34px;height:34px;background:${B.colors.primaryFaint};border-radius:2px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}

/* Buttons */
.btn{display:inline-flex;align-items:center;gap:5px;padding:7px 16px;font-family:'${B.fonts.body}',sans-serif;font-size:10px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;border-radius:2px;cursor:pointer;transition:all 0.15s;border:none;}
.btn-primary{background:${B.colors.primary};color:${B.colors.white};}
.btn-primary:hover{background:${B.colors.primaryLight};}
.btn-outline{background:transparent;color:${B.colors.primary};border:1px solid ${B.colors.primary};}
.btn-outline:hover{background:${B.colors.primaryFaint};}
.btn-ghost{background:transparent;color:${B.colors.textLight};border:1px solid ${B.colors.stone};}
.btn-ghost:hover{background:${B.colors.cream};color:${B.colors.text};}
.btn-danger{background:transparent;color:#8B2020;border:1px solid #E8BEBE;}
.btn-danger:hover{background:#FDF0F0;}
.btn-sm{padding:4px 11px;font-size:9px;}
.btn-accent{background:${B.colors.accent};color:${B.colors.white};border:none;}
.btn-accent:hover{opacity:0.9;}

/* Forms */
.form-group{margin-bottom:14px;}
.form-label{display:block;font-size:9px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:${B.colors.textLight};margin-bottom:5px;}
.form-input{width:100%;padding:8px 11px;font-family:'${B.fonts.body}',sans-serif;font-size:13px;color:${B.colors.text};background:${B.colors.white};border:1px solid ${B.colors.stone};border-radius:2px;outline:none;transition:border-color 0.15s;}
.form-input:focus{border-color:${B.colors.primary};}
.form-select{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%238A8880' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 9px center;}
.form-textarea{resize:vertical;min-height:70px;}
.form-row{display:grid;grid-template-columns:1fr 1fr;gap:11px;}
.form-row-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:11px;}

/* Multi-select checkboxes */
.multi-check{display:flex;flex-wrap:wrap;gap:8px;}
.multi-check-item{display:flex;align-items:center;gap:6px;padding:6px 12px;border:1px solid ${B.colors.stone};border-radius:20px;cursor:pointer;font-size:11px;font-weight:500;transition:all 0.15s;user-select:none;}
.multi-check-item.selected{background:${B.colors.primary};color:${B.colors.white};border-color:${B.colors.primary};}
.multi-check-item:not(.selected):hover{border-color:${B.colors.accent};}

/* Modal */
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;z-index:100;padding:16px;}
.modal{background:${B.colors.white};border-radius:3px;width:100%;max-width:540px;max-height:90vh;overflow-y:auto;}
.modal-lg{max-width:700px;}
.modal-header{padding:22px 26px 18px;border-bottom:1px solid ${B.colors.stone};display:flex;align-items:center;justify-content:space-between;}
.modal-title{font-family:'${B.fonts.heading}',serif;font-size:22px;font-weight:300;}
.modal-close{background:none;border:none;cursor:pointer;color:${B.colors.textLight};font-size:20px;line-height:1;padding:2px;}
.modal-body{padding:22px 26px;}
.modal-footer{padding:14px 26px;border-top:1px solid ${B.colors.stone};display:flex;justify-content:flex-end;gap:8px;}

/* Color swatch input */
.color-row{display:flex;align-items:center;gap:10px;margin-bottom:10px;}
.color-swatch{width:32px;height:32px;border-radius:2px;border:1px solid ${B.colors.stone};flex-shrink:0;cursor:pointer;}
.color-input{padding:6px 10px;font-size:12px;font-family:monospace;}

/* Misc */
.divider{height:1px;background:${B.colors.stone};margin:20px 0;}
.section-title{font-family:'${B.fonts.heading}',serif;font-size:19px;font-weight:300;color:${B.colors.text};margin-bottom:14px;}
.empty{text-align:center;padding:36px 16px;color:${B.colors.textLight};font-size:12px;}
.empty-icon{font-size:28px;margin-bottom:8px;opacity:0.35;}
.info-box{padding:11px 14px;background:${B.colors.primaryFaint};border-radius:2px;font-size:12px;color:${B.colors.textMid};margin-bottom:14px;}
.flex{display:flex;} .items-center{align-items:center;} .items-start{align-items:flex-start;} .justify-between{justify-content:space-between;} .justify-end{justify-content:flex-end;}
.gap-6{gap:6px;} .gap-8{gap:8px;} .gap-12{gap:12px;} .gap-16{gap:16px;}
.w-full{width:100%;} .flex-1{flex:1;}
.mt-4{margin-top:4px;} .mt-8{margin-top:8px;} .mt-12{margin-top:12px;} .mt-16{margin-top:16px;} .mt-20{margin-top:20px;} .mt-24{margin-top:24px;}
.mb-4{margin-bottom:4px;} .mb-8{margin-bottom:8px;} .mb-12{margin-bottom:12px;} .mb-16{margin-bottom:16px;} .mb-20{margin-bottom:20px;} .mb-24{margin-bottom:24px;}
.text-light{color:${B.colors.textLight};font-size:11px;}
.text-sm{font-size:12px;}
.font-500{font-weight:500;}
.login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:${B.colors.cream};padding:16px;}
.login-card{background:${B.colors.white};border:1px solid ${B.colors.stone};border-radius:3px;padding:44px 36px;width:100%;max-width:360px;text-align:center;}
.login-logo{font-family:'${B.fonts.heading}',serif;font-weight:300;font-size:26px;letter-spacing:0.14em;text-transform:uppercase;color:${B.colors.text};}
.login-sub{font-family:'${B.fonts.heading}',serif;font-style:italic;font-size:15px;color:${B.colors.accent};margin-top:1px;margin-bottom:28px;}
.mode-strip{display:flex;background:#F0EDE9;border-radius:2px;overflow:hidden;margin-bottom:22px;}
.mode-btn{flex:1;padding:8px;font-size:10px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;border:none;cursor:pointer;transition:all 0.15s;font-family:'${B.fonts.body}',sans-serif;}
.review-card{background:${B.colors.primaryFaint};border:1px solid ${B.colors.stone};border-radius:3px;padding:20px 22px;text-align:center;}
.refer-card{background:${B.colors.accentFaint};border:1px solid ${B.colors.stone};border-radius:3px;padding:20px 22px;}
.service-section{border:1px solid ${B.colors.stone};border-radius:3px;overflow:hidden;margin-bottom:20px;}
.service-section-header{padding:14px 18px;display:flex;align-items:center;justify-content:space-between;}
.service-section-body{padding:18px;border-top:1px solid ${B.colors.stone};}
`;
}

// â”€â”€ Icon â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ICON_PATHS = {
  home:"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10",
  clients:"M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8 M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75",
  calendar:"M8 2v4 M16 2v4 M3 10h18 M3 6a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6z",
  docs:"M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
  files:"M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z",
  settings:"M12 15a3 3 0 100-6 3 3 0 000 6z M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06-.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z",
  plus:"M12 5v14 M5 12h14",
  edit:"M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7 M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
  trash:"M3 6h18 M8 6V4h8v2 M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6 M10 11v6 M14 11v6",
  link:"M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71 M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71",
  check:"M20 6L9 17l-5-5",
  logout:"M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4 M16 17l5-5-5-5 M21 12H9",
  download:"M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4 M7 10l5 5 5-5 M12 15V3",
  star:"M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
  users:"M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8 M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75",
  palette:"M12 22C6.49 22 2 17.52 2 12c0-5.52 4.48-10 10-10 4.95 0 9.13 3.59 9.88 8.37.19 1.2-.8 2.31-2.01 2.31-1.17 0-2.09-.9-2.16-2.05C17.38 7.47 14.94 5.5 12 5.5c-3.58 0-6.5 2.92-6.5 6.5s2.92 6.5 6.5 6.5c1.8 0 3.43-.73 4.61-1.92",
  refresh:"M1 4v6h6 M23 20v-6h-6 M20.49 9A9 9 0 005.64 5.64L1 10 M23 14l-4.64 4.36A9 9 0 013.51 15",
  book:"M4 19.5A2.5 2.5 0 016.5 17H20 M4 19.5v-15A2.5 2.5 0 016.5 2H20v20H6.5A2.5 2.5 0 014 19.5z",
  paint:"M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z M12 8v8 M8 12h8",
};
const Ic = ({n,s=14}) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    {(ICON_PATHS[n]||"").split(" M").map((d,i)=><path key={i} d={(i===0?"":"M")+d}/>)}
  </svg>
);

// â”€â”€ Small UI atoms â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function Modal({title,onClose,children,footer,large}){
  return(
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className={`modal${large?" modal-lg":""}`}>
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          <button className="modal-close" onClick={onClose}>Ã—</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer&&<div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

function ServiceBadge({serviceId,services}){
  const svc=services.find(s=>s.id===serviceId);
  if(!svc)return null;
  return(
    <span className="badge" style={{background:svc.color+"22",color:svc.color}}>
      <span className="badge-dot" style={{background:svc.color}}/>
      {svc.label}
    </span>
  );
}

function Avatar({name,color="#555749",size=38}){
  const fg=color==="#DEC3B9"||color==="#B1A496"?"#2A2A28":"#FFFFFF";
  return(
    <div className="avatar" style={{width:size,height:size,background:color,color:fg,fontSize:size*0.32}}>
      {initials(name)}
    </div>
  );
}

function StageBar({serviceId,stage,services}){
  const svc=services.find(s=>s.id===serviceId);
  if(!svc)return null;
  const pct=Math.round((stage/(svc.stages.length-1))*100);
  return(
    <div style={{marginTop:10}}>
      <div className="flex justify-between mb-4">
        <span style={{fontSize:11,fontWeight:500,color:"#555749"}}>{svc.stages[stage]}</span>
        <span style={{fontSize:11,color:"#8A8880"}}>{stage+1}/{svc.stages.length}</span>
      </div>
      <div className="stage-track"><div className="stage-fill" style={{width:pct+"%",background:svc.color}}/></div>
    </div>
  );
}

function StageSteps({serviceId,stage,services}){
  const svc=services.find(s=>s.id===serviceId);
  if(!svc)return null;
  return(
    <div className="stage-steps">
      {svc.stages.map((s,i)=>(
        <div key={i} className={`stage-step${i<stage?" done":""}${i===stage?" current":""}`}>
          <div className="step-dot" style={i===stage?{borderColor:svc.color,boxShadow:`0 0 0 3px ${svc.color}30`}:i<stage?{background:svc.color,borderColor:svc.color}:{}}>{i<stage?<Ic n="check" s={8}/>:i+1}</div>
          <div className="step-label">{s}</div>
        </div>
      ))}
    </div>
  );
}

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// MODALS
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•

function ClientModal({client,onSave,onClose,services}){
  const blank={id:uid(),name:"",email:"",phone:"",businessName:"",code:"",startDate:today(),notes:"",invoiceUrl:"",services:[],meetings:[],documents:[],files:[]};
  const [form,setForm]=useState(client||blank);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const toggleService=(sid)=>{
    const existing=form.services.find(s=>s.serviceId===sid);
    if(existing){
      setForm(f=>({...f,services:f.services.filter(s=>s.serviceId!==sid)}));
    } else {
      const svc=services.find(s=>s.id===sid);
      const autoDocs=(svc?.autoDocs||[]).map(d=>({id:uid(),...d,url:"",date:today(),visible:true}));
      const newDocs=[...form.documents,...autoDocs.filter(ad=>!form.documents.some(d=>d.name===ad.name))];
      setForm(f=>({...f,services:[...f.services,{serviceId:sid,stage:0}],documents:newDocs}));
    }
  };

  const setStage=(sid,stage)=>setForm(f=>({...f,services:f.services.map(s=>s.serviceId===sid?{...s,stage:Number(stage)}:s)}));

  return(
    <Modal title={client?"Edit Client":"Add Client"} onClose={onClose} large
      footer={<><button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button><button className="btn btn-primary btn-sm" onClick={()=>onSave(form)}>Save Client</button></>}>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Client Name</label><input className="form-input" value={form.name} onChange={e=>set("name",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Business Name</label><input className="form-input" value={form.businessName} onChange={e=>set("businessName",e.target.value)}/></div>
      </div>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={form.email} onChange={e=>set("email",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={form.phone} onChange={e=>set("phone",e.target.value)}/></div>
      </div>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Start Date</label><input className="form-input" type="date" value={form.startDate} onChange={e=>set("startDate",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Portal Code</label><input className="form-input" value={form.code} onChange={e=>set("code",e.target.value.toUpperCase())} placeholder="e.g. MAYA2024"/></div>
      </div>
      <div className="form-group">
        <label className="form-label">Invoice Link</label>
        <input className="form-input" value={form.invoiceUrl||""} onChange={e=>set("invoiceUrl",e.target.value)} placeholder="Paste PayPal, Wave, Stripe, etc. invoice link"/>
        <div className="text-light mt-4">If set, an "Pay Invoice" button appears on this client's portal overview. Leave blank to hide it.</div>
      </div>

      <div className="form-group">
        <label className="form-label">Services (select all that apply)</label>
        <div className="multi-check">
          {services.map(svc=>(
            <div key={svc.id} className={`multi-check-item${form.services.some(s=>s.serviceId===svc.id)?" selected":""}`}
              style={form.services.some(s=>s.serviceId===svc.id)?{background:svc.color,borderColor:svc.color}:{}}
              onClick={()=>toggleService(svc.id)}>
              <span className="badge-dot" style={{background:form.services.some(s=>s.serviceId===svc.id)?"rgba(255,255,255,0.7)":svc.color}}/>
              {svc.label}
            </div>
          ))}
        </div>
      </div>

      {form.services.map(s=>{
        const svc=services.find(sv=>sv.id===s.serviceId);
        if(!svc)return null;
        return(
          <div key={s.serviceId} className="form-group">
            <label className="form-label">{svc.label} â€” Current Stage</label>
            <select className="form-input form-select" value={s.stage} onChange={e=>setStage(s.serviceId,e.target.value)}>
              {svc.stages.map((st,i)=><option key={i} value={i}>{st}</option>)}
            </select>
          </div>
        );
      })}

      <div className="form-group"><label className="form-label">Internal Notes</label><textarea className="form-input form-textarea" value={form.notes} onChange={e=>set("notes",e.target.value)}/></div>
      {form.services.length>0&&(
        <div className="info-box">Auto-documents for selected services have been added to this client's documents tab. You can review and adjust them after saving.</div>
      )}
    </Modal>
  );
}

function MeetingModal({meeting,onSave,onClose}){
  const [form,setForm]=useState(meeting||{id:uid(),title:"",date:today(),time:"",link:"",notes:""});
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  return(
    <Modal title={meeting?"Edit Meeting":"Add Meeting"} onClose={onClose}
      footer={<><button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button><button className="btn btn-primary btn-sm" onClick={()=>onSave(form)}>Save</button></>}>
      <div className="form-group"><label className="form-label">Title</label><input className="form-input" value={form.title} onChange={e=>set("title",e.target.value)} placeholder="e.g. Discovery Call"/></div>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Date</label><input className="form-input" type="date" value={form.date} onChange={e=>set("date",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Time</label><input className="form-input" value={form.time} onChange={e=>set("time",e.target.value)} placeholder="10:00 AM"/></div>
      </div>
      <div className="form-group"><label className="form-label">Meeting Link</label><input className="form-input" value={form.link} onChange={e=>set("link",e.target.value)} placeholder="https://meet.google.com/..."/></div>
      <div className="form-group"><label className="form-label">Notes for Client</label><textarea className="form-input form-textarea" value={form.notes} onChange={e=>set("notes",e.target.value)}/></div>
    </Modal>
  );
}

function DocModal({doc,onSave,onClose}){
  const [form,setForm]=useState(doc||{id:uid(),name:"",type:"Contract",url:"",date:today(),visible:true});
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  return(
    <Modal title={doc?"Edit Document":"Add Document"} onClose={onClose}
      footer={<><button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button><button className="btn btn-primary btn-sm" onClick={()=>onSave(form)}>Save</button></>}>
      <div className="form-group"><label className="form-label">Document Name</label><input className="form-input" value={form.name} onChange={e=>set("name",e.target.value)}/></div>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Type</label>
          <select className="form-input form-select" value={form.type} onChange={e=>set("type",e.target.value)}>
            {DOC_TYPES.map(t=><option key={t}>{t}</option>)}
          </select>
        </div>
        <div className="form-group"><label className="form-label">Date</label><input className="form-input" type="date" value={form.date} onChange={e=>set("date",e.target.value)}/></div>
      </div>
      <div className="form-group"><label className="form-label">URL / Link</label><input className="form-input" value={form.url} onChange={e=>set("url",e.target.value)} placeholder="https://drive.google.com/..."/></div>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <input type="checkbox" id="vis" checked={form.visible} onChange={e=>set("visible",e.target.checked)} style={{width:15,height:15,accentColor:"#555749"}}/>
        <label htmlFor="vis" className="form-label" style={{margin:0}}>Visible to client</label>
      </div>
    </Modal>
  );
}

function FileModal({file,onSave,onClose}){
  const [form,setForm]=useState(file||{id:uid(),name:"",url:"",date:today()});
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  return(
    <Modal title={file?"Edit File Delivery":"Add File Delivery"} onClose={onClose}
      footer={<><button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button><button className="btn btn-primary btn-sm" onClick={()=>onSave(form)}>Save</button></>}>
      <div className="form-group"><label className="form-label">Folder / File Name</label><input className="form-input" value={form.name} onChange={e=>set("name",e.target.value)} placeholder="e.g. Maya â€” Final Brand Files"/></div>
      <div className="form-group"><label className="form-label">Google Drive Link</label><input className="form-input" value={form.url} onChange={e=>set("url",e.target.value)} placeholder="https://drive.google.com/drive/folders/..."/></div>
      <div className="form-group"><label className="form-label">Date Available</label><input className="form-input" type="date" value={form.date} onChange={e=>set("date",e.target.value)}/></div>
    </Modal>
  );
}

// â”€â”€ Service Type Config Modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function ServiceTypeModal({svc,onSave,onClose}){
  const blank={id:uid(),label:"",color:"#555749",stages:["Inquiry","Booked","Complete"],questionnaireUrl:"",autoDocs:[]};
  const [form,setForm]=useState(svc?JSON.parse(JSON.stringify(svc)):blank);
  const [stagesText,setStagesText]=useState((svc?svc.stages:blank.stages).join("\n"));
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const addAutoDoc=()=>setForm(f=>({...f,autoDocs:[...f.autoDocs,{name:"",type:"Welcome Guide"}]}));
  const setAutoDoc=(i,k,v)=>setForm(f=>({...f,autoDocs:f.autoDocs.map((d,j)=>j===i?{...d,[k]:v}:d)}));
  const delAutoDoc=(i)=>setForm(f=>({...f,autoDocs:f.autoDocs.filter((_,j)=>j!==i)}));

  const handleSave=()=>{
    const stages=stagesText.split("\n").map(s=>s.trim()).filter(Boolean);
    onSave({...form,stages});
  };

  return(
    <Modal title={svc?"Edit Service Type":"Add Service Type"} onClose={onClose} large
      footer={<><button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button><button className="btn btn-primary btn-sm" onClick={handleSave}>Save Service Type</button></>}>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Service Name</label><input className="form-input" value={form.label} onChange={e=>set("label",e.target.value)} placeholder="e.g. Brand Photography"/></div>
        <div className="form-group">
          <label className="form-label">Color</label>
          <div className="flex items-center gap-8">
            <input type="color" value={form.color} onChange={e=>set("color",e.target.value)} style={{width:38,height:34,border:"1px solid #D5D4D2",borderRadius:2,cursor:"pointer",padding:2}}/>
            <input className="form-input color-input" value={form.color} onChange={e=>set("color",e.target.value)} style={{fontFamily:"monospace",flex:1}}/>
          </div>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Stages (one per line)</label>
        <textarea className="form-input form-textarea" style={{minHeight:120,fontFamily:"monospace",fontSize:12}} value={stagesText} onChange={e=>setStagesText(e.target.value)}/>
        <div className="text-light mt-4">Enter each stage name on its own line, in order.</div>
      </div>
      <div className="form-group">
        <label className="form-label">Questionnaire Link</label>
        <input className="form-input" value={form.questionnaireUrl||""} onChange={e=>set("questionnaireUrl",e.target.value)} placeholder="https://tally.so/r/..."/>
        <div className="text-light mt-4">Clients booked for this service will see a "Complete Your Questionnaire" button in their portal linking here. Leave blank to hide it. Update this any time the form changes â€” no code edits needed.</div>
      </div>
      <div className="form-group">
        <div className="flex justify-between items-center mb-8">
          <label className="form-label" style={{margin:0}}>Auto-Documents When Booked</label>
          <button className="btn btn-ghost btn-sm" onClick={addAutoDoc}><Ic n="plus" s={11}/> Add</button>
        </div>
        {form.autoDocs.length===0&&<div className="text-light">No auto-documents. Add documents that should be automatically created when a client books this service.</div>}
        {form.autoDocs.map((d,i)=>(
          <div key={i} className="flex gap-8 mb-8 items-center">
            <input className="form-input" style={{flex:2}} value={d.name} onChange={e=>setAutoDoc(i,"name",e.target.value)} placeholder="Document name"/>
            <select className="form-input form-select" style={{flex:1}} value={d.type} onChange={e=>setAutoDoc(i,"type",e.target.value)}>
              {DOC_TYPES.map(t=><option key={t}>{t}</option>)}
            </select>
            <button className="btn btn-danger btn-sm" onClick={()=>delAutoDoc(i)}><Ic n="trash" s={11}/></button>
          </div>
        ))}
      </div>
    </Modal>
  );
}

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// ADMIN SECTIONS
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•

function CodeRequests(){
  const [requests,setRequests]=useState([]);
  const [loaded,setLoaded]=useState(false);

  useEffect(()=>{ load("eac_code_requests",[]).then(r=>{setRequests(r);setLoaded(true);}); },[]);

  const dismiss=async(id)=>{
    const next=requests.filter(r=>r.id!==id);
    setRequests(next);
    await save("eac_code_requests",next);
  };

  if(!loaded||requests.length===0)return null;

  return(
    <div className="mb-24">
      <p className="section-title">Access Code Requests</p>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {requests.slice().reverse().map(r=>(
          <div key={r.id} className="meeting-card" style={{alignItems:"center"}}>
            <div className="flex-1">
              <div style={{fontWeight:500,fontSize:13}}>{r.email}</div>
              <div className="text-light">Requested {new Date(r.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</div>
            </div>
            <div className="flex gap-8">
              <a href={`mailto:${r.email}?subject=Your Edith Ave Creative Portal Code`} className="btn btn-outline btn-sm">Email Code</a>
              <button className="btn btn-ghost btn-sm" onClick={()=>dismiss(r.id)}><Ic n="trash" s={11}/></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Dashboard({clients,services,onSelectClient}){
  const active=clients.filter(c=>c.services.some(s=>{const svc=services.find(sv=>sv.id===s.serviceId);return svc&&s.stage<svc.stages.length-1;}));
  const complete=clients.filter(c=>c.services.every(s=>{const svc=services.find(sv=>sv.id===s.serviceId);return svc&&s.stage===svc.stages.length-1;}));
  const upcoming=clients.flatMap(c=>c.meetings.map(m=>({...m,client:c}))).filter(m=>m.date>=today()).sort((a,b)=>a.date.localeCompare(b.date)).slice(0,5);

  return(
    <div>
      <CodeRequests/>
      <div className="grid-4 mb-24">
        <div className="stat-card"><div className="stat-label">Total Clients</div><div className="stat-value">{clients.length}</div></div>
        <div className="stat-card"><div className="stat-label">Active Projects</div><div className="stat-value">{active.length}</div></div>
        <div className="stat-card"><div className="stat-label">Complete</div><div className="stat-value">{complete.length}</div></div>
        <div className="stat-card"><div className="stat-label">Upcoming Meetings</div><div className="stat-value">{upcoming.length}</div></div>
      </div>
      <div className="grid-2">
        <div>
          <p className="section-title">Active Projects</p>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {active.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No active projects</div>}
            {active.map(c=>(
              <div key={c.id} className="client-card" onClick={()=>onSelectClient(c)}>
                <div className="flex items-center gap-12 mb-8">
                  <Avatar name={c.name} color={services.find(s=>s.id===c.services[0]?.serviceId)?.color||"#555749"}/>
                  <div className="flex-1"><div style={{fontWeight:500,fontSize:13}}>{c.name}</div><div className="text-light">{c.businessName}</div></div>
                </div>
                <div className="flex gap-6 flex-wrap mb-8">
                  {c.services.map(s=><ServiceBadge key={s.serviceId} serviceId={s.serviceId} services={services}/>)}
                </div>
                {c.services.slice(0,2).map(s=><StageBar key={s.serviceId} serviceId={s.serviceId} stage={s.stage} services={services}/>)}
              </div>
            ))}
          </div>
        </div>
        <div>
          <p className="section-title">Upcoming Meetings</p>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {upcoming.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No upcoming meetings</div>}
            {upcoming.map(m=>{
              const d=new Date(m.date+"T12:00:00");
              return(
                <div key={m.id} className="meeting-card">
                  <div className="meeting-date-block">
                    <div className="meeting-month">{d.toLocaleDateString("en-US",{month:"short"})}</div>
                    <div className="meeting-day">{d.getDate()}</div>
                  </div>
                  <div className="flex-1">
                    <div className="meeting-title">{m.title}</div>
                    <div className="meeting-time">{m.client.name} Â· {m.time}</div>
                    {m.link&&m.link!=="#"&&<a href={m.link} style={{fontSize:11,marginTop:4,display:"block"}}>Join â†’</a>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function ClientList({clients,services,onSelect,onAdd,onDelete}){
  const [search,setSearch]=useState("");
  const [filter,setFilter]=useState("all");
  const filtered=clients.filter(c=>{
    const mS=filter==="all"||c.services.some(s=>s.serviceId===filter);
    const mQ=!search||c.name.toLowerCase().includes(search.toLowerCase())||c.businessName.toLowerCase().includes(search.toLowerCase());
    return mS&&mQ;
  });
  return(
    <div>
      <div className="flex justify-between items-center mb-16">
        <div className="flex gap-8 flex-wrap">
          <button className={`btn btn-sm ${filter==="all"?"btn-primary":"btn-ghost"}`} onClick={()=>setFilter("all")}>All</button>
          {services.map(s=><button key={s.id} className={`btn btn-sm ${filter===s.id?"btn-primary":"btn-ghost"}`} onClick={()=>setFilter(s.id)}>{s.label}</button>)}
        </div>
        <div className="flex gap-8">
          <input className="form-input" style={{width:180}} placeholder="Searchâ€¦" value={search} onChange={e=>setSearch(e.target.value)}/>
          <button className="btn btn-primary btn-sm" onClick={onAdd}><Ic n="plus" s={12}/> Add Client</button>
        </div>
      </div>
      <div className="card">
        <table className="tbl">
          <thead><tr><th>Client</th><th>Services</th><th>Start Date</th><th>Code</th><th></th></tr></thead>
          <tbody>
            {filtered.length===0&&<tr><td colSpan={5} style={{textAlign:"center",padding:28,color:"#8A8880"}}>No clients found</td></tr>}
            {filtered.map(c=>(
              <tr key={c.id} style={{cursor:"pointer"}} onClick={()=>onSelect(c)}>
                <td>
                  <div className="flex items-center gap-10">
                    <Avatar name={c.name} color={services.find(s=>s.id===c.services[0]?.serviceId)?.color||"#555749"} size={32}/>
                    <div><div style={{fontWeight:500}}>{c.name}</div><div className="text-light">{c.businessName}</div></div>
                  </div>
                </td>
                <td><div className="flex gap-6 flex-wrap">{c.services.map(s=><ServiceBadge key={s.serviceId} serviceId={s.serviceId} services={services}/>)}</div></td>
                <td className="text-light">{fmtDate(c.startDate)}</td>
                <td><span className="tag">{c.code}</span></td>
                <td onClick={e=>e.stopPropagation()}><button className="btn btn-danger btn-sm" onClick={()=>onDelete(c.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ClientDetail({client,services,onUpdate,onBack}){
  const [tab,setTab]=useState("overview");
  const [editing,setEditing]=useState(false);
  const [addMtg,setAddMtg]=useState(false);
  const [editMtg,setEditMtg]=useState(null);
  const [addDoc,setAddDoc]=useState(false);
  const [editDoc,setEditDoc]=useState(null);
  const [addFile,setAddFile]=useState(false);
  const [editFile,setEditFile]=useState(null);

  const upd=(patch)=>onUpdate({...client,...patch});
  const saveMtg=(m)=>{
    const meetings=editMtg?client.meetings.map(x=>x.id===m.id?m:x):[...client.meetings,m];
    upd({meetings});setAddMtg(false);setEditMtg(null);
  };
  const delMtg=(id)=>upd({meetings:client.meetings.filter(m=>m.id!==id)});
  const saveDoc=(d)=>{
    const documents=editDoc?client.documents.map(x=>x.id===d.id?d:x):[...client.documents,d];
    upd({documents});setAddDoc(false);setEditDoc(null);
  };
  const delDoc=(id)=>upd({documents:client.documents.filter(d=>d.id!==id)});
  const saveFile=(f)=>{
    const files=editFile?client.files.map(x=>x.id===f.id?f:x):[...client.files,f];
    upd({files});setAddFile(false);setEditFile(null);
  };
  const delFile=(id)=>upd({files:client.files.filter(f=>f.id!==id)});
  const setStage=(sid,stage)=>upd({services:client.services.map(s=>s.serviceId===sid?{...s,stage:Number(stage)}:s)});

  return(
    <div>
      {editing&&<ClientModal client={client} onSave={c=>{onUpdate(c);setEditing(false);}} onClose={()=>setEditing(false)} services={services}/>}
      {addMtg&&<MeetingModal onSave={saveMtg} onClose={()=>setAddMtg(false)}/>}
      {editMtg&&<MeetingModal meeting={editMtg} onSave={saveMtg} onClose={()=>setEditMtg(null)}/>}
      {addDoc&&<DocModal onSave={saveDoc} onClose={()=>setAddDoc(false)}/>}
      {editDoc&&<DocModal doc={editDoc} onSave={saveDoc} onClose={()=>setEditDoc(null)}/>}
      {addFile&&<FileModal onSave={saveFile} onClose={()=>setAddFile(false)}/>}
      {editFile&&<FileModal file={editFile} onSave={saveFile} onClose={()=>setEditFile(null)}/>}

      <button className="btn btn-ghost btn-sm mb-16" onClick={onBack}>â† All Clients</button>

      {/* Header */}
      <div className="card mb-20">
        <div style={{background:"#555749",padding:"22px 22px 18px",borderRadius:"3px 3px 0 0"}}>
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-14">
              <Avatar name={client.name} color={services.find(s=>s.id===client.services[0]?.serviceId)?.color||"#B1A496"} size={48}/>
              <div>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:24,fontWeight:300,color:"#FFFFFF"}}>{client.name}</div>
                <div style={{fontSize:12,color:"rgba(255,255,255,0.55)",marginTop:2}}>{client.businessName} Â· {client.email}</div>
              </div>
            </div>
            <button className="btn btn-sm" style={{background:"rgba(255,255,255,0.12)",color:"#fff",border:"1px solid rgba(255,255,255,0.2)"}} onClick={()=>setEditing(true)}><Ic n="edit" s={11}/> Edit</button>
          </div>
        </div>
        <div className="card-body">
          <div className="flex gap-6 flex-wrap mb-12">
            {client.services.map(s=><ServiceBadge key={s.serviceId} serviceId={s.serviceId} services={services}/>)}
          </div>
          {client.services.map(s=>{
            const svc=services.find(sv=>sv.id===s.serviceId);
            if(!svc)return null;
            return(
              <div key={s.serviceId} className="service-section mb-12">
                <div className="service-section-header" style={{background:svc.color+"15"}}>
                  <span style={{fontWeight:500,fontSize:13,color:svc.color}}>{svc.label}</span>
                  <select className="form-input form-select" style={{width:"auto",fontSize:11,padding:"3px 26px 3px 8px"}} value={s.stage} onChange={e=>setStage(s.serviceId,e.target.value)}>
                    {svc.stages.map((st,i)=><option key={i} value={i}>{st}</option>)}
                  </select>
                </div>
                <div className="service-section-body"><StageSteps serviceId={s.serviceId} stage={s.stage} services={services}/></div>
              </div>
            );
          })}
          {client.notes&&<div style={{padding:"10px 14px",background:"#F2F1EE",borderRadius:2,fontSize:12,color:"#555749",fontStyle:"italic",marginTop:8}}>{client.notes}</div>}
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",borderBottom:"1px solid #D5D4D2",marginBottom:20}}>
        {["overview","meetings","documents","files"].map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={{padding:"9px 18px",fontSize:10,fontWeight:600,letterSpacing:"0.06em",textTransform:"uppercase",color:tab===t?"#555749":"#8A8880",borderBottom:tab===t?"2px solid #555749":"2px solid transparent",marginBottom:-1,background:"none",border:"none",borderBottom:tab===t?"2px solid #555749":"2px solid transparent",cursor:"pointer"}}>
            {t.charAt(0).toUpperCase()+t.slice(1)}
          </button>
        ))}
      </div>

      {tab==="overview"&&(
        <div className="grid-2">
          <div>
            <div className="flex justify-between items-center mb-12">
              <p className="section-title" style={{margin:0}}>Meetings</p>
              <button className="btn btn-outline btn-sm" onClick={()=>setAddMtg(true)}><Ic n="plus" s={11}/> Add</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {client.meetings.slice(0,3).map(m=>{const d=new Date(m.date+"T12:00:00");return(
                <div key={m.id} className="meeting-card">
                  <div className="meeting-date-block"><div className="meeting-month">{d.toLocaleDateString("en-US",{month:"short"})}</div><div className="meeting-day">{d.getDate()}</div></div>
                  <div className="flex-1"><div className="meeting-title">{m.title}</div><div className="meeting-time">{m.time}</div></div>
                </div>
              );})}
              {client.meetings.length===0&&<div className="empty">No meetings yet</div>}
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center mb-12">
              <p className="section-title" style={{margin:0}}>Documents</p>
              <button className="btn btn-outline btn-sm" onClick={()=>setAddDoc(true)}><Ic n="plus" s={11}/> Add</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {client.documents.slice(0,4).map(d=>(
                <div key={d.id} className="file-card">
                  <div className="file-icon"><Ic n="docs" s={15}/></div>
                  <div className="flex-1"><div style={{fontSize:13,fontWeight:500}}>{d.name}</div><div className="text-light">{d.type}{!d.visible&&" Â· Hidden"}</div></div>
                </div>
              ))}
              {client.documents.length===0&&<div className="empty">No documents yet</div>}
            </div>
          </div>
        </div>
      )}

      {tab==="meetings"&&(
        <div>
          <div className="flex justify-between mb-16"><p className="section-title" style={{margin:0}}>All Meetings</p><button className="btn btn-primary btn-sm" onClick={()=>setAddMtg(true)}><Ic n="plus" s={11}/> Add Meeting</button></div>
          {client.meetings.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No meetings scheduled yet</div>}
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {client.meetings.map(m=>{const d=new Date(m.date+"T12:00:00");return(
              <div key={m.id} className="meeting-card">
                <div className="meeting-date-block"><div className="meeting-month">{d.toLocaleDateString("en-US",{month:"short"})}</div><div className="meeting-day">{d.getDate()}</div></div>
                <div className="flex-1">
                  <div className="meeting-title">{m.title}</div>
                  <div className="meeting-time">{m.time}</div>
                  {m.notes&&<div className="meeting-note">{m.notes}</div>}
                  {m.link&&m.link!=="#"&&<a href={m.link} style={{fontSize:11,marginTop:4,display:"block"}}>Join meeting â†’</a>}
                </div>
                <div className="flex gap-6">
                  <button className="btn btn-ghost btn-sm" onClick={()=>setEditMtg(m)}><Ic n="edit" s={11}/></button>
                  <button className="btn btn-danger btn-sm" onClick={()=>delMtg(m.id)}><Ic n="trash" s={11}/></button>
                </div>
              </div>
            );})}
          </div>
        </div>
      )}

      {tab==="documents"&&(
        <div>
          <div className="flex justify-between mb-16"><p className="section-title" style={{margin:0}}>Documents</p><button className="btn btn-primary btn-sm" onClick={()=>setAddDoc(true)}><Ic n="plus" s={11}/> Add Document</button></div>
          {client.documents.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No documents yet</div>}
          <div className="card">
            <table className="tbl">
              <thead><tr><th>Name</th><th>Type</th><th>Date</th><th>Visibility</th><th></th></tr></thead>
              <tbody>
                {client.documents.map(d=>(
                  <tr key={d.id}>
                    <td><span style={{fontWeight:500}}>{d.name}</span></td>
                    <td><span className="tag">{d.type}</span></td>
                    <td className="text-light">{fmtDate(d.date)}</td>
                    <td>
                      <button className={`btn btn-sm ${d.visible?"btn-outline":"btn-ghost"}`} style={{minWidth:72}} onClick={()=>saveDoc({...d,visible:!d.visible})}>
                        {d.visible?"Visible":"Hidden"}
                      </button>
                    </td>
                    <td>
                      <div className="flex gap-6">
                        <button className="btn btn-ghost btn-sm" onClick={()=>setEditDoc(d)}><Ic n="edit" s={11}/></button>
                        <button className="btn btn-danger btn-sm" onClick={()=>delDoc(d.id)}><Ic n="trash" s={11}/></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab==="files"&&(
        <div>
          <div className="flex justify-between mb-16"><p className="section-title" style={{margin:0}}>File Delivery</p><button className="btn btn-primary btn-sm" onClick={()=>setAddFile(true)}><Ic n="plus" s={11}/> Add Files</button></div>
          <div className="info-box">File deliveries link to Google Drive folders. Paste a shareable Drive link when files are ready for the client.</div>
          {client.files.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No files delivered yet</div>}
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {client.files.map(f=>(
              <div key={f.id} className="file-card">
                <div className="file-icon"><Ic n="files" s={15}/></div>
                <div className="flex-1">
                  <div style={{fontSize:13,fontWeight:500}}>{f.name}</div>
                  <div className="text-light">Available {fmtDate(f.date)}</div>
                  {f.url&&f.url!=="#"&&<a href={f.url} style={{fontSize:11}}>Open in Drive â†’</a>}
                </div>
                <div className="flex gap-6">
                  <button className="btn btn-ghost btn-sm" onClick={()=>setEditFile(f)}><Ic n="edit" s={11}/></button>
                  <button className="btn btn-danger btn-sm" onClick={()=>delFile(f.id)}><Ic n="trash" s={11}/></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// â”€â”€ Service Types Manager â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function ServiceTypes({services,onUpdate}){
  const [editing,setEditing]=useState(null);
  const [adding,setAdding]=useState(false);

  const save=(svc)=>{
    const next=editing?services.map(s=>s.id===svc.id?svc:s):[...services,svc];
    onUpdate(next);setEditing(null);setAdding(false);
  };
  const del=(id)=>{if(!confirm("Delete this service type?"))return;onUpdate(services.filter(s=>s.id!==id));};

  return(
    <div>
      {(adding||editing)&&<ServiceTypeModal svc={editing} onSave={save} onClose={()=>{setAdding(false);setEditing(null);}}/>}
      <div className="flex justify-between items-center mb-16">
        <p className="section-title" style={{margin:0}}>Service Types</p>
        <button className="btn btn-primary btn-sm" onClick={()=>setAdding(true)}><Ic n="plus" s={11}/> Add Service Type</button>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {services.map(svc=>(
          <div key={svc.id} className="card">
            <div className="service-section-header" style={{background:svc.color+"18"}}>
              <div className="flex items-center gap-12">
                <div style={{width:12,height:12,borderRadius:"50%",background:svc.color,flexShrink:0}}/>
                <span style={{fontWeight:500,fontSize:14}}>{svc.label}</span>
                <span className="text-light">{svc.stages.length} stages</span>
              </div>
              <div className="flex gap-8">
                <button className="btn btn-ghost btn-sm" onClick={()=>setEditing(svc)}><Ic n="edit" s={11}/> Edit</button>
                <button className="btn btn-danger btn-sm" onClick={()=>del(svc.id)}><Ic n="trash" s={11}/></button>
              </div>
            </div>
            <div className="card-body">
              <div className="flex gap-6 flex-wrap mb-10">
                {svc.stages.map((st,i)=><span key={i} className="tag">{i+1}. {st}</span>)}
              </div>
              <div className="mb-10">
                <div className="form-label" style={{marginBottom:4}}>Questionnaire link</div>
                {svc.questionnaireUrl
                  ? <a href={svc.questionnaireUrl} target="_blank" rel="noreferrer" className="text-light" style={{fontSize:12,color:svc.color,wordBreak:"break-all"}}>{svc.questionnaireUrl}</a>
                  : <span className="text-light" style={{fontStyle:"italic"}}>Not set â€” client won't see a questionnaire button for this service</span>}
              </div>
              {svc.autoDocs.length>0&&(
                <div>
                  <div className="form-label" style={{marginBottom:6}}>Auto-documents on booking</div>
                  <div className="flex gap-6 flex-wrap">
                    {svc.autoDocs.map((d,i)=><span key={i} className="badge" style={{background:svc.color+"18",color:svc.color}}><Ic n="docs" s={10}/>{d.name}</span>)}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// â”€â”€ Appearances â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function Appearances({brand,onUpdate}){
  const [form,setForm]=useState(JSON.parse(JSON.stringify(brand)));
  const set=(path,val)=>{
    const keys=path.split(".");
    setForm(f=>{
      const next=JSON.parse(JSON.stringify(f));
      let obj=next;
      keys.slice(0,-1).forEach(k=>obj=obj[k]);
      obj[keys[keys.length-1]]=val;
      return next;
    });
  };
  const [saved,setSaved]=useState(false);
  const handleSave=()=>{onUpdate(form);setSaved(true);setTimeout(()=>setSaved(false),2000);};

  const colorFields=[
    ["Primary (sidebar, buttons)","colors.primary"],
    ["Primary Light (hover)","colors.primaryLight"],
    ["Primary Faint (backgrounds)","colors.primaryFaint"],
    ["Accent (sidebar sub, badges)","colors.accent"],
    ["Accent Faint (card backgrounds)","colors.accentFaint"],
    ["Stone (borders)","colors.stone"],
    ["Cream (page background)","colors.cream"],
    ["Text","colors.text"],
    ["Text Mid","colors.textMid"],
    ["Text Light","colors.textLight"],
  ];

  const getVal=(path)=>{const keys=path.split(".");let o=form;keys.forEach(k=>o=o?.[k]);return o||"";};

  return(
    <div>
      <div className="flex justify-between items-center mb-20">
        <p className="section-title" style={{margin:0}}>Appearances</p>
        <button className="btn btn-primary btn-sm" onClick={handleSave}>{saved?"Saved âœ“":"Save Changes"}</button>
      </div>

      <div className="grid-2" style={{gap:20}}>
        {/* Business info */}
        <div className="card">
          <div className="card-header"><span className="card-title">Business Info</span></div>
          <div className="card-body">
            <div className="form-group"><label className="form-label">Business Name</label><input className="form-input" value={form.businessName} onChange={e=>set("businessName",e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Tagline (shown under name)</label><input className="form-input" value={form.tagline} onChange={e=>set("tagline",e.target.value)}/></div>
          </div>
        </div>

        {/* Fonts */}
        <div className="card">
          <div className="card-header"><span className="card-title">Typography</span></div>
          <div className="card-body">
            <div className="form-group">
              <label className="form-label">Heading Font Name</label>
              <input className="form-input" value={form.fonts.heading} onChange={e=>set("fonts.heading",e.target.value)} placeholder="Cormorant Garamond"/>
              <div className="text-light mt-4">Must match the Google Fonts family name exactly.</div>
            </div>
            <div className="form-group">
              <label className="form-label">Heading Font URL (Google Fonts embed URL)</label>
              <input className="form-input" value={form.fonts.headingUrl} onChange={e=>set("fonts.headingUrl",e.target.value)} placeholder="https://fonts.googleapis.com/css2?family=..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Body Font Name</label>
              <input className="form-input" value={form.fonts.body} onChange={e=>set("fonts.body",e.target.value)} placeholder="Montserrat"/>
            </div>
            <div className="form-group">
              <label className="form-label">Body Font URL (Google Fonts embed URL)</label>
              <input className="form-input" value={form.fonts.bodyUrl} onChange={e=>set("fonts.bodyUrl",e.target.value)} placeholder="https://fonts.googleapis.com/css2?family=..."/>
            </div>
            <div className="info-box" style={{marginTop:4}}>To find Google Fonts URLs: go to fonts.google.com â†’ select a font â†’ click "Get embed code" â†’ copy the @import URL.</div>
          </div>
        </div>
      </div>

      {/* Colors */}
      <div className="card mt-20">
        <div className="card-header"><span className="card-title">Brand Colors</span></div>
        <div className="card-body">
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:"8px 20px"}}>
            {colorFields.map(([label,path])=>(
              <div key={path}>
                <div className="form-label" style={{marginBottom:4}}>{label}</div>
                <div className="color-row">
                  <input type="color" value={getVal(path)} onChange={e=>set(path,e.target.value)} style={{width:36,height:32,border:"1px solid #D5D4D2",borderRadius:2,cursor:"pointer",padding:2,flexShrink:0}}/>
                  <input className="form-input color-input" value={getVal(path)} onChange={e=>set(path,e.target.value)} style={{fontFamily:"monospace"}}/>
                  <div style={{width:32,height:32,background:getVal(path),borderRadius:2,border:"1px solid #D5D4D2",flexShrink:0}}/>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Preview strip */}
      <div className="card mt-20">
        <div className="card-header"><span className="card-title">Live Preview</span></div>
        <div className="card-body">
          <div style={{display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
            <div style={{background:getVal("colors.primary"),color:"#fff",padding:"10px 18px",borderRadius:2,fontFamily:`'${form.fonts.heading}',serif`,fontSize:20,letterSpacing:"0.1em"}}>{form.businessName}</div>
            <div style={{background:getVal("colors.accent"),color:"#fff",padding:"6px 14px",borderRadius:20,fontSize:11,fontWeight:600}}>Badge</div>
            <div style={{background:getVal("colors.cream"),border:`1px solid ${getVal("colors.stone")}`,padding:"10px 16px",borderRadius:2,fontSize:13,fontFamily:`'${form.fonts.body}',sans-serif`}}>Body text sample</div>
            <div style={{background:getVal("colors.primaryFaint"),padding:"8px 14px",borderRadius:2,fontSize:12,color:getVal("colors.textMid")}}>Faint background</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// CLIENT PORTAL VIEW
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
function ClientPortal({client,services,brand,onLogout}){
  const [page,setPage]=useState("overview");
  const visibleDocs=client.documents.filter(d=>d.visible);
  const B=brand.colors;

  const navItems=[
    {id:"overview",icon:"home",label:"Overview"},
    {id:"progress",icon:"refresh",label:"My Project"},
    {id:"meetings",icon:"calendar",label:"Meetings"},
    {id:"documents",icon:"docs",label:"Documents"},
    {id:"files",icon:"files",label:"My Files"},
    {id:"review",icon:"star",label:"Leave a Review"},
    {id:"refer",icon:"users",label:"Refer a Friend"},
    {id:"book",icon:"refresh",label:"Book Again"},
  ];

  return(
    <div className="app-wrap">
      <div className="client-sidebar">
        <div className="client-sb-header">
          <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontWeight:300,fontSize:17,color:"#fff",letterSpacing:"0.12em",textTransform:"uppercase"}}>{brand.businessName.split(" ").slice(0,2).join(" ")}</div>
          <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontStyle:"italic",fontSize:12,color:B.accent,marginTop:1,marginBottom:10}}>{brand.tagline}</div>
          <div className="client-sb-name">{client.name}</div>
          <div className="client-sb-biz">{client.businessName}</div>
          <div className="flex gap-4 flex-wrap mt-8">
            {client.services.map(s=>{
              const svc=services.find(sv=>sv.id===s.serviceId);
              if(!svc)return null;
              return <span key={s.serviceId} className="badge" style={{background:svc.color+"30",color:svc.color,fontSize:9}}>{svc.label}</span>;
            })}
          </div>
        </div>
        <div className="client-nav">
          <div className="client-nav-section">Navigation</div>
          {navItems.map(item=>(
            <button key={item.id} className={`client-nav-item${page===item.id?" active":""}`} onClick={()=>setPage(item.id)}>
              <Ic n={item.icon} s={13}/>{item.label}
            </button>
          ))}
        </div>
        <div className="client-bottom">
          <button className="client-nav-item" onClick={onLogout}><Ic n="logout" s={13}/> Sign Out</button>
        </div>
      </div>

      <div className="main">
        <div className="topbar">
          <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontSize:20,fontWeight:300}}>{navItems.find(n=>n.id===page)?.label||"Portal"}</div>
          <span className="tag">Client Portal</span>
        </div>

        <div className="content">

          {page==="overview"&&(
            <div>
              <div style={{background:B.primary,borderRadius:3,padding:"24px 26px",marginBottom:20,color:"#fff"}}>
                <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontSize:28,fontWeight:300,marginBottom:4}}>Welcome back, {client.name.split(" ")[0]}.</div>
                <div style={{fontSize:12,color:"rgba(255,255,255,0.6)"}}>Started {fmtDate(client.startDate)} Â· {client.services.length} service{client.services.length>1?"s":""} booked</div>
              </div>

              {(client.services.some(s=>services.find(sv=>sv.id===s.serviceId)?.questionnaireUrl)||client.invoiceUrl)&&(
                <div className="mb-20">
                  <p className="section-title">Assignments</p>
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    {client.services.map(s=>{
                      const svc=services.find(sv=>sv.id===s.serviceId);
                      if(!svc||!svc.questionnaireUrl)return null;
                      return(
                        <div key={s.serviceId} className="file-card">
                          <div className="file-icon" style={{background:svc.color+"20"}}><Ic n="docs" s={14}/></div>
                          <div className="flex-1">
                            <div style={{fontSize:13,fontWeight:500}}>Complete Your {svc.label} Questionnaire</div>
                            <div className="text-light">Helps us prepare for your planning call â€” takes about 10â€“15 minutes</div>
                          </div>
                          <a href={svc.questionnaireUrl} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm">Start</a>
                        </div>
                      );
                    })}
                    {client.invoiceUrl&&(
                      <div className="file-card">
                        <div className="file-icon" style={{background:B.accentFaint}}><Ic n="link" s={14}/></div>
                        <div className="flex-1">
                          <div style={{fontSize:13,fontWeight:500}}>Pay Your Invoice</div>
                          <div className="text-light">Securely complete payment for your project</div>
                        </div>
                        <a href={client.invoiceUrl} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm">Pay Now</a>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="grid-2 mb-20">
                {client.services.map(s=>{
                  const svc=services.find(sv=>sv.id===s.serviceId);
                  if(!svc)return null;
                  const pct=Math.round((s.stage/(svc.stages.length-1))*100);
                  return(
                    <div key={s.serviceId} className="card">
                      <div className="card-header" style={{padding:"14px 18px"}}>
                        <span style={{fontSize:13,fontWeight:500,color:svc.color}}>{svc.label}</span>
                        <span className="text-light">{svc.stages[s.stage]}</span>
                      </div>
                      <div style={{padding:"14px 18px"}}>
                        <div className="stage-track"><div className="stage-fill" style={{width:pct+"%",background:svc.color}}/></div>
                        <div className="text-light mt-4">{s.stage+1} of {svc.stages.length} stages complete</div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="grid-2">
                <div>
                  <p className="section-title">Next Meeting</p>
                  {client.meetings.filter(m=>m.date>=today()).sort((a,b)=>a.date.localeCompare(b.date)).slice(0,1).map(m=>{
                    const d=new Date(m.date+"T12:00:00");
                    return(
                      <div key={m.id} className="meeting-card">
                        <div className="meeting-date-block"><div className="meeting-month">{d.toLocaleDateString("en-US",{month:"short"})}</div><div className="meeting-day">{d.getDate()}</div></div>
                        <div className="flex-1">
                          <div className="meeting-title">{m.title}</div>
                          <div className="meeting-time">{m.time}</div>
                          {m.notes&&<div className="meeting-note">{m.notes}</div>}
                          {m.link&&m.link!=="#"&&<a href={m.link} className="btn btn-outline btn-sm" style={{marginTop:8,display:"inline-flex"}}>Join Meeting</a>}
                        </div>
                      </div>
                    );
                  })}
                  {client.meetings.filter(m=>m.date>=today()).length===0&&<div className="empty">No upcoming meetings yet.</div>}
                </div>
                <div>
                  <p className="section-title">Recent Documents</p>
                  {visibleDocs.length===0&&<div className="empty">Documents will appear here as your project progresses.</div>}
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    {visibleDocs.slice(0,3).map(d=>(
                      <div key={d.id} className="file-card">
                        <div className="file-icon"><Ic n="docs" s={14}/></div>
                        <div className="flex-1"><div style={{fontSize:13,fontWeight:500}}>{d.name}</div><div className="text-light">{d.type}</div></div>
                        {d.url&&d.url!=="#"&&<a href={d.url} className="btn btn-ghost btn-sm"><Ic n="link" s={11}/> Open</a>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {page==="progress"&&(
            <div>
              <p className="section-title">Project Progress</p>
              {client.services.map(s=>{
                const svc=services.find(sv=>sv.id===s.serviceId);
                if(!svc)return null;
                return(
                  <div key={s.serviceId} className="card mb-20">
                    <div className="card-header" style={{background:svc.color+"12"}}>
                      <span style={{fontWeight:500,color:svc.color}}>{svc.label}</span>
                      <span style={{fontSize:12,color:"#8A8880"}}>Stage {s.stage+1} of {svc.stages.length}: <strong style={{color:svc.color}}>{svc.stages[s.stage]}</strong></span>
                    </div>
                    <div className="card-body"><StageSteps serviceId={s.serviceId} stage={s.stage} services={services}/></div>
                  </div>
                );
              })}
            </div>
          )}

          {page==="meetings"&&(
            <div>
              <p className="section-title">All Meetings</p>
              {client.meetings.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No meetings scheduled yet â€” check back soon.</div>}
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {client.meetings.sort((a,b)=>a.date.localeCompare(b.date)).map(m=>{
                  const d=new Date(m.date+"T12:00:00");
                  const past=m.date<today();
                  return(
                    <div key={m.id} className="meeting-card" style={{opacity:past?0.6:1}}>
                      <div className="meeting-date-block"><div className="meeting-month">{d.toLocaleDateString("en-US",{month:"short"})}</div><div className="meeting-day">{d.getDate()}</div></div>
                      <div className="flex-1">
                        <div className="flex items-center gap-8"><div className="meeting-title">{m.title}</div>{past&&<span className="tag" style={{fontSize:9}}>Past</span>}</div>
                        <div className="meeting-time">{m.time}</div>
                        {m.notes&&<div className="meeting-note">{m.notes}</div>}
                        {m.link&&m.link!=="#"&&!past&&<a href={m.link} className="btn btn-outline btn-sm" style={{marginTop:8,display:"inline-flex"}}>Join Meeting</a>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {page==="documents"&&(
            <div>
              <p className="section-title">Your Documents</p>
              {visibleDocs.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>Documents will appear here as your project progresses.</div>}
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {visibleDocs.map(d=>(
                  <div key={d.id} className="file-card">
                    <div className="file-icon"><Ic n="docs" s={14}/></div>
                    <div className="flex-1"><div style={{fontSize:13,fontWeight:500}}>{d.name}</div><div className="text-light">{d.type} Â· {fmtDate(d.date)}</div></div>
                    {d.url&&d.url!=="#"&&<a href={d.url} className="btn btn-primary btn-sm"><Ic n="link" s={11}/> Open</a>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {page==="files"&&(
            <div>
              <p className="section-title">Your Files</p>
              {client.files.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>Your final files will appear here when they're ready. We'll be in touch!</div>}
              <div style={{display:"flex",flexDirection:"column",gap:12}}>
                {client.files.map(f=>(
                  <div key={f.id} style={{border:`1px solid ${B.accent}`,borderRadius:3,padding:"18px 22px",background:B.accentFaint}}>
                    <div className="flex items-center gap-14">
                      <div style={{width:44,height:44,background:B.primary,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,color:"#fff"}}>
                        <Ic n="files" s={20}/>
                      </div>
                      <div className="flex-1">
                        <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontSize:17,fontWeight:300}}>{f.name}</div>
                        <div className="text-light mt-4">Available {fmtDate(f.date)}</div>
                      </div>
                      {f.url&&f.url!=="#"&&<a href={f.url} className="btn btn-primary"><Ic n="download" s={13}/> Access Files</a>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {page==="review"&&(
            <div style={{maxWidth:560}}>
              <p className="section-title">Leave a Review</p>
              <div className="review-card mb-16">
                <div style={{fontSize:32,marginBottom:12}}>â­</div>
                <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontSize:22,fontWeight:300,marginBottom:8}}>How was your experience?</div>
                <div style={{fontSize:13,color:"#555749",lineHeight:1.6,marginBottom:16}}>Your feedback means the world and helps other small businesses find the creative support they need. If you loved working together, I'd be so grateful for a review.</div>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {[
                  {label:"Google Review",url:"#",desc:"The most visible place for new clients to find you."},
                  {label:"Facebook Review",url:"#",desc:"Share your experience on Facebook."},
                ].map(r=>(
                  <div key={r.label} className="file-card">
                    <div className="file-icon" style={{background:B.primaryFaint}}><Ic n="star" s={14}/></div>
                    <div className="flex-1"><div style={{fontSize:13,fontWeight:500}}>{r.label}</div><div className="text-light">{r.desc}</div></div>
                    <a href={r.url} className="btn btn-primary btn-sm">Write a Review</a>
                  </div>
                ))}
              </div>
              <div style={{marginTop:20,padding:"14px 16px",background:B.accentFaint,borderRadius:3,fontSize:12,color:B.textMid}}>
                <strong>Prefer to share privately?</strong> Reply to any of our project emails â€” I read every one and truly appreciate it.
              </div>
            </div>
          )}

          {page==="refer"&&(
            <div style={{maxWidth:560}}>
              <p className="section-title">Refer a Friend</p>
              <div className="refer-card mb-16">
                <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontSize:22,fontWeight:300,marginBottom:8}}>Know someone who could use this?</div>
                <div style={{fontSize:13,color:"#555749",lineHeight:1.7}}>The best compliment you can give is a referral. If you know another small business owner who's been putting off their brand, photos, or website â€” send them my way. I'll take good care of them.</div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="form-group"><label className="form-label">Their Name</label><input className="form-input" placeholder="Friend's name"/></div>
                  <div className="form-group"><label className="form-label">Their Email</label><input className="form-input" type="email" placeholder="friend@example.com"/></div>
                  <div className="form-group"><label className="form-label">What They Might Need</label>
                    <select className="form-input form-select">
                      <option>Not sure yet</option>
                      {services.map(s=><option key={s.id}>{s.label}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">A Note (optional)</label><textarea className="form-input form-textarea" placeholder="Anything helpful I should know before reaching out?"/></div>
                  <button className="btn btn-primary w-full" style={{justifyContent:"center"}}>Send the Introduction</button>
                </div>
              </div>
              <div style={{marginTop:12,fontSize:11,color:B.textLight,textAlign:"center"}}>I'll reach out to them personally within 48 hours.</div>
            </div>
          )}

          {page==="book"&&(
            <div style={{maxWidth:560}}>
              <p className="section-title">Book Again</p>
              <div style={{background:B.primary,borderRadius:3,padding:"22px 24px",marginBottom:20,color:"#fff"}}>
                <div style={{fontFamily:`'${brand.fonts.heading}',serif`,fontSize:22,fontWeight:300,marginBottom:6}}>Ready for the next step?</div>
                <div style={{fontSize:13,color:"rgba(255,255,255,0.7)",lineHeight:1.6}}>Whether it's expanding on what we've built or starting something new â€” I'd love to keep working together.</div>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {services.map(svc=>(
                  <div key={svc.id} className="file-card">
                    <div className="file-icon" style={{background:svc.color+"20"}}><div style={{width:8,height:8,borderRadius:"50%",background:svc.color}}/></div>
                    <div className="flex-1">
                      <div style={{fontSize:13,fontWeight:500}}>{svc.label}</div>
                      <div className="text-light">Inquire to get started</div>
                    </div>
                    <a href={`mailto:hello@edithavecreative.com?subject=Booking Inquiry â€” ${svc.label}`} className="btn btn-outline btn-sm">Inquire</a>
                  </div>
                ))}
              </div>
              <div style={{marginTop:16,padding:"12px 14px",background:B.primaryFaint,borderRadius:3,fontSize:12,color:B.textMid}}>
                Returning clients receive priority scheduling. Reach out anytime at <a href="mailto:hello@edithavecreative.com">hello@edithavecreative.com</a>
              </div>
            </div>
          )}

          <div className="divider mt-24"/>
          <div style={{textAlign:"center",fontSize:12,color:B.textLight}}>Questions? <a href="mailto:hello@edithavecreative.com">hello@edithavecreative.com</a></div>
        </div>
      </div>
    </div>
  );
}

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// ADMIN SHELL
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
function AdminShell({clients,setClients,services,setServices,brand,setBrand,onLogout}){
  const [nav,setNav]=useState("dashboard");
  const [selected,setSelected]=useState(null);
  const [adding,setAdding]=useState(false);

  const saveClient=(updated)=>{
    const next=clients.map(c=>c.id===updated.id?updated:c);
    setClients(next);save("eac_clients",next);
    if(selected?.id===updated.id)setSelected(updated);
  };
  const addClient=(c)=>{const next=[...clients,c];setClients(next);save("eac_clients",next);setAdding(false);};
  const delClient=(id)=>{
    if(!confirm("Delete this client?"))return;
    const next=clients.filter(c=>c.id!==id);
    setClients(next);save("eac_clients",next);
    if(selected?.id===id)setSelected(null);
  };
  const updateServices=(svcs)=>{setServices(svcs);save("eac_services",svcs);};
  const updateBrand=(b)=>{setBrand(b);save("eac_brand",b);};

  const navSections=[
    {label:"Studio",items:[
      {id:"dashboard",icon:"home",label:"Dashboard"},
      {id:"clients",icon:"clients",label:"Clients"},
      {id:"calendar",icon:"calendar",label:"Meetings"},
      {id:"documents",icon:"docs",label:"Documents"},
    ]},
    {label:"Settings",items:[
      {id:"services",icon:"settings",label:"Service Types"},
      {id:"appearances",icon:"paint",label:"Appearances"},
    ]},
  ];

  const allMeetings=clients.flatMap(c=>c.meetings.map(m=>({...m,client:c}))).sort((a,b)=>a.date.localeCompare(b.date));
  const allDocs=clients.flatMap(c=>c.documents.map(d=>({...d,client:c})));

  return(
    <div className="app-wrap">
      <div className="sidebar">
        <div className="sb-logo">
          <div className="sb-logo-main">{brand.businessName.split(" ").slice(0,2).join(" ")}</div>
          <div className="sb-logo-sub">{brand.tagline}</div>
        </div>
        {navSections.map(section=>(
          <div key={section.label}>
            <div className="sb-section">{section.label}</div>
            {section.items.map(item=>(
              <button key={item.id} className={`nav-item${nav===item.id&&!selected?" active":""}`} onClick={()=>{setNav(item.id);setSelected(null);}}>
                <Ic n={item.icon} s={14}/>{item.label}
              </button>
            ))}
          </div>
        ))}
        <div className="nav-bottom">
          <button className="nav-item" onClick={onLogout}><Ic n="logout" s={14}/> Sign Out</button>
        </div>
      </div>

      <div className="main">
        <div className="topbar">
          <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:300}}>{selected?selected.name:navSections.flatMap(s=>s.items).find(i=>i.id===nav)?.label}</div>
          <span className="tag">Studio View</span>
        </div>
        <div className="content">
          {adding&&<ClientModal onSave={addClient} onClose={()=>setAdding(false)} services={services}/>}
          {selected
            ? <ClientDetail client={selected} services={services} onUpdate={saveClient} onBack={()=>setSelected(null)}/>
            : nav==="dashboard"?<Dashboard clients={clients} services={services} onSelectClient={c=>{setSelected(c);setNav("clients");}}/>
            : nav==="clients"?<ClientList clients={clients} services={services} onSelect={setSelected} onAdd={()=>setAdding(true)} onDelete={delClient}/>
            : nav==="calendar"?(
              <div>
                <p className="section-title mb-16">All Meetings</p>
                {allMeetings.length===0&&<div className="empty"><div className="empty-icon">âœ¦</div>No meetings scheduled</div>}
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {allMeetings.map(m=>{const d=new Date(m.date+"T12:00:00");return(
                    <div key={m.id} className="meeting-card">
                      <div className="meeting-date-block"><div className="meeting-month">{d.toLocaleDateString("en-US",{month:"short"})}</div><div className="meeting-day">{d.getDate()}</div></div>
                      <div className="flex-1"><div className="meeting-title">{m.title}</div><div className="meeting-time">{m.client.name} Â· {m.time}</div></div>
                      <div className="flex gap-8 items-center">
                        {m.client.services.slice(0,1).map(s=><ServiceBadge key={s.serviceId} serviceId={s.serviceId} services={services}/>)}
                        {m.link&&m.link!=="#"&&<a href={m.link} className="btn btn-ghost btn-sm">Join</a>}
                      </div>
                    </div>
                  );})}
                </div>
              </div>
            )
            : nav==="documents"?(
              <div>
                <p className="section-title mb-16">All Documents</p>
                <div className="card">
                  <table className="tbl">
                    <thead><tr><th>Document</th><th>Client</th><th>Type</th><th>Date</th><th>Visibility</th></tr></thead>
                    <tbody>
                      {allDocs.length===0&&<tr><td colSpan={5} style={{textAlign:"center",padding:28,color:"#8A8880"}}>No documents yet</td></tr>}
                      {allDocs.map(d=>(
                        <tr key={d.id}>
                          <td style={{fontWeight:500}}>{d.name}</td>
                          <td><div className="flex items-center gap-8"><Avatar name={d.client.name} color={services.find(s=>s.id===d.client.services[0]?.serviceId)?.color||"#B1A496"} size={24}/>{d.client.name}</div></td>
                          <td><span className="tag">{d.type}</span></td>
                          <td className="text-light">{fmtDate(d.date)}</td>
                          <td><span style={{fontSize:11,fontWeight:500,color:d.visible?"#555749":"#8A8880"}}>{d.visible?"Visible":"Hidden"}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )
            : nav==="services"?<ServiceTypes services={services} onUpdate={updateServices}/>
            : nav==="appearances"?<Appearances brand={brand} onUpdate={updateBrand}/>
            : null
          }
        </div>
      </div>
    </div>
  );
}

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// LOGIN
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
function Login({clients,brand,onLogin}){
  const [mode,setMode]=useState("client");
  const [code,setCode]=useState("");
  const [err,setErr]=useState("");
  const [forgot,setForgot]=useState(false);
  const [forgotEmail,setForgotEmail]=useState("");
  const [forgotSent,setForgotSent]=useState(false);
  const B=brand.colors;

  const attempt=()=>{
    if(code.trim().toUpperCase()===ADMIN_CODE){onLogin("admin",null);return;}
    const c=clients.find(cl=>cl.code===code.trim().toUpperCase());
    if(c){onLogin("client",c);return;}
    setErr("That code doesn't match any active projects. Check with Nicole if you think something's off.");
  };

  const submitForgot=async()=>{
    try{
      const existing=await load("eac_code_requests",[]);
      await save("eac_code_requests",[...existing,{id:uid(),email:forgotEmail.trim(),date:new Date().toISOString()}]);
    }catch(_){}
    setForgotSent(true);
  };

  if(forgot){
    return(
      <div className="login-wrap">
        <div className="login-card">
          <div className="login-logo">{brand.businessName.split(" ").slice(0,2).join(" ")}</div>
          <div className="login-sub">{brand.tagline}</div>
          {!forgotSent ? (
            <>
              <div className="form-label" style={{textAlign:"left",marginBottom:5,marginTop:10}}>Your Email Address</div>
              <input className="form-input" type="email" style={{marginBottom:4}}
                placeholder="you@yourbusiness.com"
                value={forgotEmail} onChange={e=>setForgotEmail(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&forgotEmail.trim()&&submitForgot()}/>
              <div style={{fontSize:11,color:B.textLight,marginTop:8,textAlign:"left",lineHeight:1.6}}>Enter the email you used when you booked, and Nicole will send your access code directly.</div>
              <button className="btn btn-primary w-full" style={{marginTop:14,justifyContent:"center"}} disabled={!forgotEmail.trim()} onClick={submitForgot}>
                Request My Code
              </button>
              <button className="btn btn-ghost w-full" style={{marginTop:8,justifyContent:"center"}} onClick={()=>{setForgot(false);setForgotSent(false);setForgotEmail("");}}>
                Back to Login
              </button>
            </>
          ) : (
            <>
              <div style={{marginTop:14,padding:"16px 14px",background:B.primaryFaint,borderRadius:3,fontSize:12,color:B.textMid,lineHeight:1.6,textAlign:"left"}}>
                Thanks! Nicole will send your access code to <strong>{forgotEmail}</strong> shortly. If you don't see it within a day, reach out directly at <a href="mailto:hello@edithavecreative.com">hello@edithavecreative.com</a>.
              </div>
              <button className="btn btn-primary w-full" style={{marginTop:14,justifyContent:"center"}} onClick={()=>{setForgot(false);setForgotSent(false);setForgotEmail("");}}>
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  return(
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">{brand.businessName.split(" ").slice(0,2).join(" ")}</div>
        <div className="login-sub">{brand.tagline}</div>
        <div className="mode-strip">
          {["client","admin"].map(m=>(
            <button key={m} className="mode-btn" onClick={()=>{setMode(m);setErr("");}}
              style={{background:mode===m?B.primary:"transparent",color:mode===m?"#fff":B.textLight}}>
              {m==="client"?"Client":"Studio"}
            </button>
          ))}
        </div>
        <div className="form-label" style={{textAlign:"left",marginBottom:5}}>{mode==="client"?"Your Access Code":"Studio Password"}</div>
        <input className="form-input" style={{textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:4}}
          placeholder={mode==="client"?"e.g. MAYA2024":"Admin code"}
          value={code} onChange={e=>{setCode(e.target.value);setErr("");}}
          onKeyDown={e=>e.key==="Enter"&&attempt()}/>
        {err&&<div style={{fontSize:11,color:"#8B2020",marginTop:4,textAlign:"left"}}>{err}</div>}
        <button className="btn btn-primary w-full" style={{marginTop:14,justifyContent:"center"}} onClick={attempt}>
          {mode==="client"?"Access My Portal":"Enter Studio"}
        </button>
        {mode==="client"&&(
          <div style={{marginTop:16,fontSize:11,color:B.textLight,lineHeight:1.6}}>
            Your access code was in your welcome email.{" "}
            <button onClick={()=>setForgot(true)} style={{background:"none",border:"none",padding:0,color:B.primary,fontWeight:600,cursor:"pointer",fontSize:11,textDecoration:"underline"}}>Forgot your code?</button>
            {" "}or email <a href="mailto:hello@edithavecreative.com">hello@edithavecreative.com</a>
          </div>
        )}
      </div>
    </div>
  );
}

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// APP ROOT
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
export default function App(){
  const [clients,setClients]=useState([]);
  const [services,setServices]=useState(DEFAULT_SERVICES);
  const [brand,setBrand]=useState(DEFAULT_BRAND);
  const [ready,setReady]=useState(false);
  const [auth,setAuth]=useState(null);

  useEffect(()=>{
    Promise.all([
      load("eac_clients",SEED_CLIENTS),
      load("eac_services",DEFAULT_SERVICES),
      load("eac_brand",DEFAULT_BRAND),
    ]).then(([c,s,b])=>{setClients(c);setServices(s);setBrand(b);setReady(true);});
  },[]);

  const css=buildCSS(brand);

  if(!ready) return(
    <>
      <style>{`body{font-family:sans-serif;display:flex;align-items:center;justify-content:center;height:100vh;background:#EFEAE7;color:#8A8880;font-size:14px;}`}</style>
      <div>Loadingâ€¦</div>
    </>
  );

  return(
    <>
      <style>{css}</style>
      {!auth
        ? <Login clients={clients} brand={brand} onLogin={(role,client)=>setAuth({role,client})}/>
        : auth.role==="admin"
          ? <AdminShell clients={clients} setClients={setClients} services={services} setServices={setServices} brand={brand} setBrand={setBrand} onLogout={()=>setAuth(null)}/>
          : <ClientPortal client={auth.client} services={services} brand={brand} onLogout={()=>setAuth(null)}/>
      }
    </>
  );
}
